import { createContext, useState } from "react";
import { ContextProviderPropsType, ContextType } from "../types/context.type";

export const Context = createContext({} as ContextType);

export const ContextProvider: React.FC<ContextProviderPropsType> = ({ children }) => {
    const [mobileSideNavigationOpen, setMobileSideNavigationOpen] = useState(false);
    const [isSideNavigationClosing, setIsSideNavigationClosing] = useState(false);
    const [activeNavItem, setActiveNavItem] = useState<string | undefined>(undefined);

    return (
        <Context.Provider
            value={{
                mobileSideNavigationOpen,
                setMobileSideNavigationOpen,
                isSideNavigationClosing,
                setIsSideNavigationClosing,
                activeNavItem,
                setActiveNavItem
            }}
        >
            {children}
        </Context.Provider>
    )
}